export default __webpack_public_path__ + "static/media/Large conference room_V.3.81622fd0.png";